var _g, _g2, _mask, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocationFaultedPoiMarker = function SvgLocationFaultedPoiMarker(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 41,
    viewBox: "0 0 36 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2237_5060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4854 7.18131C27.6885 9.38415 28.9485 12.3575 28.999 15.4725C29.0496 18.5876 27.8866 21.6002 25.7561 23.8733L25.4854 24.1533L19.8281 29.8093C19.1102 30.5267 18.0144 31.2999 17.0001 31.3333C15.9858 31.3667 15.1289 30.6579 14.3654 29.9893L14.1734 29.8093L8.51474 24.152C6.26429 21.9015 5 18.8493 5 15.6666C5 12.484 6.26429 9.43176 8.51474 7.18131C10.7652 4.93086 13.8175 3.66656 17.0001 3.66656C20.1827 3.66656 23.235 4.93086 25.4854 7.18131Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2237_5060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3641 9.63599C25.0164 11.2881 25.9614 13.5181 25.9993 15.8544C26.0372 18.1907 25.1649 20.4502 23.5671 22.155L23.3641 22.365L19.1211 26.607C18.5827 27.145 17.8599 27.4583 17.0992 27.4834C16.3385 27.5084 15.5967 27.2434 15.0241 26.742L14.8801 26.607L10.6361 22.364C8.94822 20.6762 8 18.387 8 16C8 13.613 8.94822 11.3238 10.6361 9.63599C12.3239 7.94816 14.6131 6.99994 17.0001 6.99994C19.387 6.99994 21.6762 7.94816 23.3641 9.63599ZM17.0001 13C16.6061 13 16.216 13.0776 15.852 13.2284C15.488 13.3791 15.1573 13.6001 14.8787 13.8787C14.6002 14.1572 14.3792 14.488 14.2284 14.8519C14.0777 15.2159 14.0001 15.606 14.0001 16C14.0001 16.394 14.0777 16.7841 14.2284 17.148C14.3792 17.512 14.6002 17.8427 14.8787 18.1213C15.1573 18.3999 15.488 18.6209 15.852 18.7716C16.216 18.9224 16.6061 19 17.0001 19C17.7957 19 18.5588 18.6839 19.1214 18.1213C19.684 17.5587 20.0001 16.7956 20.0001 16C20.0001 15.2043 19.684 14.4413 19.1214 13.8787C18.5588 13.3161 17.7957 13 17.0001 13Z",
    fill: "url(#paint0_linear_2237_5060)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_2237_5060",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 16,
    width: 12,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 19,
    y: 16,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1342 22.6981L25.1342 18L21 25.6019H25.1217V30.3L29.2 22.6981L25.1342 22.6981Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1342 22.6981L25.1342 18L21 25.6019H25.1217V30.3L29.2 22.6981L25.1342 22.6981Z",
    fill: "#C62828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1342 22.6981L23.6342 22.6981C23.6342 23.5265 24.3058 24.1981 25.1342 24.1981V22.6981ZM25.1342 18L26.6342 18C26.6342 17.314 26.1688 16.7154 25.5039 16.5463C24.8391 16.3772 24.1442 16.6807 23.8165 17.2834L25.1342 18ZM21 25.6019L19.6823 24.8853C19.4295 25.3501 19.4403 25.9136 19.7106 26.3684C19.981 26.8232 20.4709 27.1019 21 27.1019V25.6019ZM25.1217 25.6019H26.6217C26.6217 24.7735 25.9501 24.1019 25.1217 24.1019V25.6019ZM25.1217 30.3H23.6217C23.6217 30.9876 24.0892 31.5872 24.7561 31.7548C25.423 31.9224 26.1184 31.6151 26.4435 31.0091L25.1217 30.3ZM29.2 22.6981L30.5218 23.4072C30.7712 22.9423 30.7581 22.3806 30.4872 21.9279C30.2163 21.4752 29.7276 21.1981 29.2 21.1981V22.6981ZM26.6342 22.6981L26.6342 18L23.6342 18L23.6342 22.6981L26.6342 22.6981ZM23.8165 17.2834L19.6823 24.8853L22.3177 26.3186L26.4519 18.7166L23.8165 17.2834ZM21 27.1019H25.1217V24.1019H21V27.1019ZM23.6217 25.6019V30.3H26.6217V25.6019H23.6217ZM26.4435 31.0091L30.5218 23.4072L27.8782 21.989L23.7999 29.5909L26.4435 31.0091ZM29.2 21.1981L25.1342 21.1981V24.1981L29.2 24.1981V21.1981Z",
    fill: "white",
    mask: "url(#path-3-outside-1_2237_5060)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2237_5060",
    x: 0,
    y: 0.666565,
    width: 36.0007,
    height: 39.6679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.262745 0 0 0 0 0.419608 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2237_5060"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2237_5060",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2237_5060",
    x1: 17.0002,
    y1: 6.99994,
    x2: 17.0002,
    y2: 27.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1565C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2196F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2237_5060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(5 5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocationFaultedPoiMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "locationFaultedPOIMarker.ac6ceb01c93f6820065ea84008e555a5.svg";